import { gql } from '@apollo/client'

export const GetXeroPaymentServicesOrganisation = gql`
  query GetXeroPaymentServicesOrganisation($entityUuid: ID!) {
    getXeroPaymentServicesConfiguration(entityUuid: $entityUuid) {
      xeroOrganisationUuid
    }
  }
`
